module.exports = __webpack_public_path__ + "img/pyunik-logo-icon.cc5918ed.png";